import SearchNavbar from "components/v2/Listings/SearchBarComponent/SearchNavbar";
import PrixImmoRouterUrlHelper from "components/v2/PrixImmobilier/PrixImmobilierComponents/PrixImmoRouterUrlHelper";
import dynamic from "next/dynamic";
import { Suspense, useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { actions as AnnuairereducerActions } from "redux/slices/v2/Annuaire";
import { decrypt } from "utils/CRYPTO/secret";
import {
  setAgencePopup,
  setAgences,
  setAnnonces,
  setLegend,
  setPricesTables,
  setPrix,
  setTransactionFullDisplay,
  setTransactionPopup,
  setTransactions,
} from "../../../redux/slices/carteprixReducer";
import CreateLegend from "../../../utils/CarteDesPrix/CreateLegend";
import GetData from "../../../utils/CarteDesPrix/GetData";
import GetDataAgences from "../../../utils/CarteDesPrix/GetDataAgences";
import GetDataAnnonces from "../../../utils/CarteDesPrix/GetDataAnnonces";
import GetDataTransactions from "../../../utils/CarteDesPrix/GetDataTransactions";
import HandleClick from "../../../utils/CarteDesPrix/HandleClick";
import nextStyles from "./PrixImmobilier.module.css";
import useTranslation from "next-translate/useTranslation";
const ListingMapPopup = dynamic(
  () => import("components/v2/Listings/ListingMapPopup"),
  {
    ssr: false,
  }
);

const SearchBar = dynamic(
  () =>
    import(
      "components/v2/PrixImmobilier/PrixImmobilierComponents/SearchBar/SearchBar"
    ),
  {
    suspense: true,
  }
);

const PopupAgenceContainer = dynamic(
  () =>
    import(
      "components/v2/PrixImmobilier/PrixImmobilierComponents/CardComponent/PopupCarteDesPrix/PopupAgenceContainer"
    ),
  {
    suspense: true,
  }
);
const ListingFullDisplay = dynamic(
  () => import("components/v3/Listings/ListingFullDisplay"),
  {
    suspense: true,
  }
);

const CardComponent = dynamic(
  () =>
    import(
      "components/v2/PrixImmobilier/PrixImmobilierComponents/CardComponent/CardComponent"
    ),
  {
    suspense: true,
  }
);

const AveragePricingAreaMobile = dynamic(
  () =>
    import(
      "components/v2/PrixImmobilier/PrixImmobilierComponents/InfoCarteDesPrix/InfosPrixLocalisation/AveragePricingAreaMobile"
    ),
  {
    suspense: true,
  }
);

const InfoCarteDesPrix = dynamic(
  () =>
    import(
      "components/v2/PrixImmobilier/PrixImmobilierComponents/InfoCarteDesPrix/InfoCarteDesPrix"
    ),
  {
    suspense: true,
  }
);

declare global {
  interface Window {
    cartedesprix: any;
    cartedesannonces: any;
  }
}
type localisation_object = {
  _id: string;
  prix_appartement: number;
  prix_villa: number;
  province: string;
  region: string;
  province_ar: string;
  indice_confiance_appartement: number;
  indice_confiance_villa: number;
  lat: number;
  lng: number;
};
export default function PrixImmobilier({
  region,
  province,
  commune,
  quartier,
  pricesSSR,
  provincesSSR,
  provincesMaroc,
  communesSSR,
}: {
  region?: string;
  province?: string;
  commune?: string;
  quartier?: string;
  pricesSSR?: localisation_object;
  provincesSSR?: localisation_object[];
  provincesMaroc?: localisation_object[];
  communesSSR?: localisation_object[];
}) {
  // const theme = useTheme();
  const dispatch = useDispatch();
  // const viewUpTOMd = useMediaQuery(theme.breakpoints.up("md"));
  let todisplay = useSelector(
    (state: { carteprix: any }) => state.carteprix.todisplay
  );
  let prix = useSelector((state: { carteprix: any }) => state.carteprix.prix);
  let provinces = useSelector(
    (state: { carteprix: any }) => state.carteprix.provinces
  );
  let communes = useSelector(
    (state: { carteprix: any }) => state.carteprix.communes
  );
  let annonces = useSelector(
    (state: { carteprix: any }) => state.carteprix.annonces
  );
  let transactions = useSelector(
    (state: { carteprix: any }) => state.carteprix.transactions
  );
  let agences = useSelector(
    (state: { carteprix: any }) => state.carteprix.agences
  );
  let agence_popup = useSelector(
    (state: { carteprix: any }) => state.carteprix.agence_popup
  );
  let agence_popup_data = useSelector(
    (state: { carteprix: any }) => state.carteprix.agence_popup_data
  );
  let transaction_popup = useSelector(
    (state: { carteprix: any }) => state.carteprix.transaction_popup
  );
  let transaction_full_display = useSelector(
    (state: { carteprix: any }) => state.carteprix.transaction_full_display
  );
  let transaction_full_display_data = useSelector(
    (state: { carteprix: any }) => state.carteprix.transaction_full_display_data
  );
  let transaction_popup_data = useSelector(
    (state: { carteprix: any }) => state.carteprix.transaction_popup_data
  );
  let from_server = useSelector(
    (state: { carteprix: any }) => state.carteprix.from_server
  );
  let legend = useSelector(
    (state: { carteprix: any }) => state.carteprix.legend
  );

  let [loadingAgences, setLoadingAgences] = useState(true);
  let [loadingAnnonces, setLoadingAnnonces] = useState(true);
  let [loadingTransactions, setLoadingTransactions] = useState(true);
  let [loadingPrices, setLoadingPrices] = useState(true);

  const [average, setAverage] = useState(true);

  let prix_villa = useSelector(
    (state: { carteprix: any }) => state.carteprix.prix_villa
  );
  let prices_redux = useSelector(
    (state: { carteprix: any }) => state.carteprix.prices
  );
  const [windowAvailable, setWindowAvailable] = useState(false);
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    if (prices_redux._id) {
      setLoadingPrices(true);
      setLoadingAgences(true);
      setLoadingAnnonces(true);
      scrollToTopFunction();
      CreateLegend(prices_redux)
        .then((res) => {
          dispatch(
            setLegend({
              data: res,
            })
          );
          scrollToTopFunction();
        })
        .catch((err) => {});
      GetData(prices_redux)
        .then((res) => {
          setLoadingPrices(false);
          dispatch(
            setPricesTables({
              data: res.data,
            })
          );
          scrollToTopFunction();
        })
        .catch((err) => {
          setLoadingPrices(false);
          scrollToTopFunction();
        });

      GetDataAgences(prices_redux)
        .then((res) => {
          setLoadingAgences(false);
          // dispatch(
          //   setAgences({
          //     data: res,
          //   })
          // );
          dispatch(
            AnnuairereducerActions.setAgences({
              agences: res.results,
              totalItems: res.totalItems,
            })
          );
          scrollToTopFunction();
        })
        .catch((err) => {
          setLoadingAgences(false);
          dispatch(
            setAgences({
              data: [],
            })
          );
          scrollToTopFunction();
        });

      GetDataAnnonces(prices_redux)
        .then((res) => {
          setLoadingAnnonces(false);
          if (res.data) {
            dispatch(
              setAnnonces({
                data: decrypt(res.data).result,
              })
            );
            scrollToTopFunction();
          } else {
            dispatch(
              setAnnonces({
                data: res,
              })
            );
            scrollToTopFunction();
          }
        })
        .catch((err) => {
          setLoadingAnnonces(false);
          scrollToTopFunction();
        });
      setLoadingTransactions(true);
      GetDataTransactions(prices_redux)
        .then((res) => {
          setLoadingTransactions(false);

          if (res.data) {
            dispatch(
              setTransactions({
                data: decrypt(res.data).result,
              })
            );
            scrollToTopFunction();
          } else {
            dispatch(
              setTransactions({
                data: res,
              })
            );
            scrollToTopFunction();
          }
        })
        .catch((err) => {
          setLoadingTransactions(false);
          scrollToTopFunction();
        });
      if (windowAvailable) {
        if (window.cartedesprix) {
          if (prices_redux.lng && prices_redux.lat) {
            HandleClick(
              window.cartedesprix,
              prices_redux.quartier
                ? "plans"
                : prices_redux.commune
                ? "communes"
                : prices_redux.province
                ? "provinces"
                : "regions",
              prices_redux,
              prices_redux.lat,
              prices_redux.lng
            );
          }
        }
      }
    }
  }, [prices_redux]);

  useEffect(() => {
    if (pricesSSR) {
      setLoadingPrices(false);
      dispatch(
        setPrix({
          data: pricesSSR,
        })
      );
    }
    if (provincesSSR || communesSSR) {
      setLoadingPrices(false);
      dispatch(
        setPricesTables({
          data: {
            provinces: provincesSSR ?? [],
            communes: communesSSR ?? [],
          },
        })
      );
    }
    if (pricesSSR) {
      //TODO: if we have Agences || annonces || transactions SSR
      // call the success action directrly ie: dispatch(setTransactions
      setLoadingAgences(true);
      GetDataAgences(pricesSSR)
        .then((res) => {
          setLoadingAgences(false);
          // dispatch(
          //   setAgences({
          //     data: res,
          //   })
          // );
          dispatch(
            AnnuairereducerActions.setAgences({
              agences: res.results,
              totalItems: res.totalItems,
            })
          );
        })
        .catch((err) => {
          setLoadingAgences(false);
          dispatch(
            setAgences({
              data: [],
            })
          );
        });
      setLoadingAnnonces(true);
      GetDataAnnonces(pricesSSR)
        .then((res) => {
          setLoadingAnnonces(false);
          if (res.data) {
            dispatch(
              setAnnonces({
                data: decrypt(res.data).result,
              })
            );
          } else {
            dispatch(
              setAnnonces({
                data: res,
              })
            );
          }
        })
        .catch((err) => {
          setLoadingAnnonces(false);
        });
      setLoadingTransactions(true);
      GetDataTransactions(pricesSSR)
        .then((res) => {
          setLoadingTransactions(false);
          if (res.data) {
            dispatch(
              setTransactions({
                data: decrypt(res.data).result,
              })
            );
          } else {
            dispatch(
              setTransactions({
                data: res,
              })
            );
          }
        })
        .catch((err) => {
          setLoadingTransactions(false);
        });
    }
  }, [pricesSSR, provincesSSR, communesSSR]);
  useEffect(() => {
    setWindowAvailable(true);
    setMatches(window.matchMedia("(min-width: 990px)").matches);
  });
  const scrollToTopFunction = () => {
    if (document.getElementById("info__prix__ aria-hidden__mobile")) {
      document
        .getElementById("info__prix__container__mobile")
        .scrollTo(-1000, -1000);
    }
    if (document.getElementById("info__prix__container")) {
      document.getElementById("info__prix__container").scrollTo(-1000, -1000);
    }
  };
  const { lang } = useTranslation("prixImmobilierMaroc");

  return (
    <>
      {transaction_full_display && (
        <Suspense fallback={<></>}>
          <ListingFullDisplay
            listing={transaction_full_display_data}
            transaction_type={"Vente"}
            onFavoriteIconPress={() => {}}
            loadingLike={false}
            liked={false}
            onClose={() => {
              dispatch(
                setTransactionPopup({
                  data: {
                    data: {},
                    popup: false,
                  },
                })
              );
              dispatch(
                setTransactionFullDisplay({
                  data: {
                    data: {},
                    popup: false,
                  },
                })
              );
            }}
          />
        </Suspense>
      )}
      <PrixImmoRouterUrlHelper />

      <div className={nextStyles.search__bar__container_mobile}>
        <SearchNavbar
          openAuthDialog={() => {
            return;
          }}
          onLogout={() => {
            return;
          }}
          component={
            <div
              className={`
                ${nextStyles.autocomplete_input_navbar_container}`}
            >
              <div>
                <Suspense fallback={<></>}>
                  <SearchBar />
                </Suspense>
              </div>
            </div>
          }
        />
      </div>

      <div
        className={`${nextStyles.PrixImmobilierPageContainer} 
          ${
            prices_redux.prix_appartement ||
            prices_redux.prix_villa ||
            agence_popup ||
            transaction_popup
              ? todisplay === "CARTE"
                ? nextStyles.PrixImmobilierPageMobileContainerWithPrices
                : ""
              : ""
          }`}
      >
        <div className={`${nextStyles.InfoCarteDesPrixContainerDesktop}`}>
          {todisplay !== "CARTE" ? (
            <div
              className={` ${nextStyles.prix__info__container}`}
              style={{ direction: lang == "ar" ? "rtl" : "ltr" }}
              id="info__prix__container"
            >
              <InfoCarteDesPrix
                setTransactionToDisplay={(row) => {
                  dispatch(
                    setTransactionFullDisplay({
                      data: {
                        data: row,
                        popup: true,
                      },
                    })
                  );
                }}
                mobile={false}
                scrollingUp={scrollToTopFunction}
                prices={from_server && pricesSSR ? pricesSSR : prices_redux}
                provinces={
                  from_server && provincesSSR ? provincesSSR : provinces
                }
                from_server={from_server}
                communes={from_server && communesSSR ? communesSSR : communes}
                annonces={annonces ?? []}
                transactions={transactions ?? []}
                agences={agences ?? []}
                loadingAnnonces={from_server ? false : loadingAnnonces}
                loadingAgences={from_server ? false : loadingAgences}
                loadingPrices={from_server ? false : loadingPrices}
                indice_confiance_appartement={
                  from_server && pricesSSR
                    ? pricesSSR.indice_confiance_appartement
                    : prices_redux.indice_confiance_appartement
                }
                indice_confiance_villa={
                  from_server && pricesSSR
                    ? pricesSSR.indice_confiance_villa
                    : prices_redux.indice_confiance_villa
                }
                provinces_maroc={
                  provincesMaroc && provincesMaroc.length > 0
                    ? provincesMaroc
                    : provincesSSR && provincesSSR.length > 0
                    ? provincesSSR
                    : []
                }
              />
            </div>
          ) : null}
          {(todisplay === "CARTE" || matches) && (
            <div
              className={`${todisplay !== "CARTE" ? nextStyles.__hidden : ""} ${
                transaction_popup ||
                agence_popup ||
                prices_redux.prix_appartement ||
                prices_redux.prix_villa
                  ? nextStyles.prix__map__container__popup
                  : nextStyles.prix__map__container
              }  `}
            >
              <div className={nextStyles.search__bar__container}>
                <Suspense fallback={<></>}>
                  <SearchBar />
                </Suspense>
              </div>
              <div
                className={`${nextStyles.map__prices__mobile} ${
                  nextStyles.desktop__hidden
                } ${todisplay !== "CARTE" ? nextStyles.__hidden : ""}`}
              >
                <Suspense fallback={<></>}>
                  <CardComponent
                    legend={legend}
                    popup={transaction_popup || agence_popup ? false : true}
                    prices={prices_redux}
                    scrollingUp={scrollToTopFunction}
                  />
                </Suspense>
              </div>
            </div>
          )}
        </div>
      </div>

      {todisplay === "CARTE" ? (
        transaction_popup ? (
          <div
            className={`${nextStyles.popup__mobile__cards} ${nextStyles.desktop__hidden} popup--mobile--cards `}
          >
            <Suspense fallback={<></>}>
              <ListingMapPopup
                listing={transaction_popup_data}
                onListingPress={(transaction) => {
                  dispatch(
                    setTransactionFullDisplay({
                      data: {
                        data: transaction,
                        popup: true,
                      },
                    })
                  );
                }}
                onClose={() => {
                  dispatch(
                    setTransactionPopup({
                      data: {
                        data: {},
                        popup: false,
                      },
                    })
                  );
                }}
                mobilePopup={true}
              />
            </Suspense>
          </div>
        ) : agence_popup ? (
          <div
            className={`${nextStyles.popup__mobile__cards} ${nextStyles.desktop__hidden} popup--mobile--cards `}
          >
            <Suspense fallback={<></>}>
              <PopupAgenceContainer
                nameEntreprise={agence_popup_data.nameEntreprise}
                countTransactions={agence_popup_data.countTransactions}
                contributeurId={agence_popup_data.responsable}
                user_image={agence_popup_data.user_image}
              />
            </Suspense>
          </div>
        ) : (prices_redux.prix_appartement || prices_redux.prix_villa) &&
          average ? (
          <div
            className={`${nextStyles.popup__mobile__cards}  ${nextStyles.desktop__hidden} popup--mobile--cards `}
          >
            <Suspense fallback={<></>}>
              <AveragePricingAreaMobile
                prices={prices_redux}
                setAverage={setAverage}
              />
            </Suspense>
          </div>
        ) : (
          <></>
        )
      ) : (
        <></>
      )}
    </>
  );
}
